import { navigate, StaticQuery } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { getImage } from '../utils';
import Truncate from 'react-truncate';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { graphql } from 'gatsby';

const Item = ({
    title,
    image,
    alt,
    slug
}) => {
    const goTo = () =>
        navigate(slug)

    return (
        <div
            onClick={goTo}
            className="c-pointer bg-white">
            <div className="container-card-overlay">
                <img
                    style={{
                        height: "250px",
                        objectFit: "cover"
                    }}
                    src={image}
                    alt={alt}
                    className="img-fluid w-100" />
                <div className="card-overlay">
                    <Truncate trimWhitespace={true} lines={2} ellipsis={<span>...</span>}>
                        {title}
                    </Truncate>
                </div>
            </div>
        </div>
    )
}

const CarouselControls = ({
    prev,
    next
}) => {
    return (
        <div className="container d-flex justify-content-between align-items-center">
            <Button
                className="primary py-2 px-4"
                onClick={prev}>
                <FontAwesomeIcon icon={faAngleLeft} />
            </Button>
            <Button
                className="primary py-2 px-4"
                onClick={next}>
                <FontAwesomeIcon icon={faAngleRight} />
            </Button>
        </div>
    )
}

const MAX_PER_SLIDE = 6;
const MAX_PER_SLIDE_MOBILE = 3;

const ProjectsGallery = ({
    data
}) => {
    const [slides, setSlides] = useState([]);
    const [slidesMobile, setSlidesMobile] = useState([]);

    const [currentSlide, setCurrentSlide] = useState(0);
    const [currentSlideMobile, setCurrentSlideMobile] = useState(0);

    useEffect(() => {
        let aux = [];
        let aux2 = [];
        const len = data.allMarkdownRemark.edges.length;
        if (len > 0) {
            const count = Math.ceil(len / MAX_PER_SLIDE);
            for (let index = 0; index < count; index++) {
                const prodSet = data.allMarkdownRemark.edges.slice(index * MAX_PER_SLIDE, (index + 1) * MAX_PER_SLIDE);
                aux.push(prodSet);
            }

            const count2 = Math.ceil(len / MAX_PER_SLIDE_MOBILE);
            for (let index = 0; index < count2; index++) {
                const prodSet = data.allMarkdownRemark.edges.slice(index * MAX_PER_SLIDE_MOBILE, (index + 1) * MAX_PER_SLIDE_MOBILE);
                aux2.push(prodSet);
            }
        }
        setSlides(aux);
        setSlidesMobile(aux2);
    }, [data]);

    const prev = () => setCurrentSlide(currentSlide - 1);
    const next = () => setCurrentSlide(currentSlide + 1);
    const updateCurrentSlide = index => {
        if (currentSlide !== index)
            setCurrentSlide(index);
    };

    const prevMobile = () => setCurrentSlideMobile(currentSlideMobile - 1);
    const nextMobile = () => setCurrentSlideMobile(currentSlideMobile + 1);
    const updateCurrentSlideMobile = index => {
        if (currentSlideMobile !== index)
            setCurrentSlideMobile(index);
    };

    return (
        <>
            {/* Displayed in desk */}
            <div className="d-none d-md-block">
                <Carousel
                    showStatus={false}
                    showThumbs={false}
                    showArrows={false}
                    selectedItem={currentSlide}
                    onChange={updateCurrentSlide}
                    emulateTouch>
                    {
                        slides.map((slide, index) => (
                            <div
                                key={`slide-${index}`}
                                className="row no-gutters pb-5">
                                {
                                    slide.map((item, index2) => {
                                        return (
                                            <div
                                                key={`projdesktop${index2}`}
                                                className={`col-md-6 col-lg-4`}>
                                                <Item
                                                    image={getImage(item.node.frontmatter.image, "featuredimage")}
                                                    alt={item.node.frontmatter.image.alt}
                                                    title={item.node.frontmatter.name}
                                                    slug={item.node.fields.slug} />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        ))
                    }
                </Carousel>
                {
                    slides.length > 1 && (
                        <div className="pt-3 pb-5">
                            <CarouselControls
                                prev={prev}
                                next={next} />
                        </div>
                    )
                }
            </div>
            {/* Displayed in mobile */}
            <div className="d-block d-md-none">
                <Carousel
                    showStatus={false}
                    showThumbs={false}
                    emulateTouch
                    selectedItem={currentSlideMobile}
                    onChange={updateCurrentSlideMobile}>
                    {
                        slidesMobile.map((slide, index) => (
                            <div
                                key={`slide-${index}`}
                                className="row no-gutters">
                                {
                                    slide.map((item, index) => (
                                        <div
                                            style={{ backgroundColor: "transparent" }}
                                            className={`col-12 px-md-0 ${(index + 1) === slide.length ? "pb-5" : "pb-3"}`}>
                                            <div
                                                key={`projmobile${index}`}>
                                                <Item
                                                    image={getImage(item.node.frontmatter.image, "featuredimage")}
                                                    alt={item.node.frontmatter.image.alt}
                                                    title={item.node.frontmatter.name}
                                                    slug={item.node.fields.slug} />
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    }
                </Carousel>
                {
                    slidesMobile.length > 1 && (
                        <div className="pt-3 pb-5">
                            <CarouselControls
                                prev={prevMobile}
                                next={nextMobile} />
                        </div>
                    )
                }
            </div>
        </>
    )
}

// export default ProjectsGallery;

export default props => (
    <StaticQuery
        query={graphql`
        query ProjectsGallery {
            allMarkdownRemark(
                sort: { order: DESC, fields: [frontmatter___date] }
                filter: { frontmatter: { templateKey: { eq: "project-post" } }}
            ) {
                edges {
                    node {
                        fields {
                            slug
                        }
                        frontmatter {
                            name
                            image {
                                featuredimage {
                                  childImageSharp {
                                      fluid {
                                          ...GatsbyImageSharpFluid
                                      }
                                  }
                                  publicURL
                                }
                                alt
                            }
                        }
                    }
                }
            }
        }
      `}
        render={(data, count) => <ProjectsGallery data={data} {...props} />}
    />
)